<template>
  <div v-if="dataLoaded">
    <v-sheet style="max-width: 120em; padding-right: 1em;">
      <v-row>
        <v-col cols="12">
          <img class="pa-md-4"  width="175" alt="PDC" src="@/assets/pdc_logo.png">
          <div style="float:right"><h3>Registration (C-1): {{registration.submitted_at  | formatDate}}</h3></div>
        </v-col>
      </v-row>


      <div id="flex-flyout" class="d-flex d-flex-row justify-space-between ">
        <v-card flat class="identification">
          <v-card-title>

            <h3 v-if="registration.committee.candidacy && registration.committee.candidacy.person">
              {{ registration.committee.candidacy.person }}</h3>
            <h3 v-else>{{ registration.committee.name }}<span
                v-if="registration.committee.acronym"> ({{ registration.committee.acronym }})</span></h3>
          </v-card-title>
          <v-card-text>

            <div v-if="registration.committee.candidacy && registration.committee.candidacy.person">
              {{ registration.committee.name }}<span
                v-if="registration.committee.acronym"> ({{ registration.committee.acronym }})</span></div>
            <div v-if="registration.committee.contact.address">
              {{ registration.committee.contact.address | titleCase }}
            </div>
            <div
                v-if="registration.committee.contact.city || registration.committee.contact.state || registration.committee.contact.postcode">
              <span
                  v-if="registration.committee.contact.city">{{ registration.committee.contact.city | titleCase }}<span
                  v-if="registration.committee.contact.state">,</span></span>
              <span v-if="registration.committee.contact.state"> {{ registration.committee.contact.state }}</span>
              <span v-if="registration.committee.contact.postcode"> {{ registration.committee.contact.postcode }}</span>
            </div>
            <div v-if="registration.committee.contact.email">{{ registration.committee.contact.email.toLowerCase() }}
            </div>
            <div v-if="registration.committee.contact.phone">{{ registration.committee.contact.phone }}</div>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title><h4>Registration Filed</h4></v-card-title>
          <v-card-text>
            <div>
              {{ registration.committee.pac_type | titleCase }}
              <span
                  v-if="registration.committee.pac_type === 'bonafide' && registration.committee.bonafide_type">{{ registration.committee.bonafide_type | titleCase }}</span>
              <span v-if="registration.committee.pac_type === 'bonafide' && registration.committee.exempt === true"> Exempt</span>
              <span v-else-if="registration.committee.pac_type === 'bonafide'"> Non-Exempt</span>
            </div>
            <div v-if="registration.committee.pac_type === 'bonafide' || registration.committee.pac_type === 'caucus'">
              <span
                  v-if="registration.committee.party_name">{{ registration.committee.party_name | titleCase }} Party</span>
            </div>
            <div v-if="isCommitteeView && registration.admin_data && registration.admin_data.reporting_type">
              {{ registration.admin_data.reporting_type | titleCase | suffix(' Reporting') }}
            </div>
            <div v-else-if="registration.committee.reporting_type">
              {{ registration.committee.reporting_type | titleCase | suffix(' Reporting') }}
            </div>
            <div v-if="registration.admin_data && registration.admin_data.mini_full_permission">Mini-to-Full Permission
              Granted
            </div>
            <div v-if="registration.submitted_at"><span class="flyout-label">Submitted date:</span>
              {{ registration.submitted_at | formatDate }}
            </div>
            <div v-if="registration.certification_email"><span class="flyout-label">Certified by</span>
              {{ registration.certification_email | email }}
            </div>
            <div v-if="registration.committee.continuing === true">Continuing</div>
            <div v-if="registration.committee.election_code">
              <span v-if="registration.committee.continuing === true">Originally targeting</span>
              {{ registration.committee.election_code }}
            </div>
            <div v-if="registration.committee.filer_id">
              {{ registration.committee.filer_id }}
            </div>
            <div
                v-if="registration.local_filing && registration.local_filing.seec && registration.local_filing.seec.required === true">
              Must also file with City of Seattle
            </div>
          </v-card-text>
        </v-card>
      </div>


      <v-card v-if="registration.committee.candidacy && registration.committee.candidacy.person">
        <v-card-title><h3>Candidacy</h3></v-card-title>
        <v-card-text>
          <div v-if="registration.committee.candidacy.person">
            {{ registration.committee.candidacy.person | titleCase }}
          </div>
          <div v-if="registration.committee.candidacy.election_code">
            {{ registration.committee.candidacy.election_code }}
          </div>
          <div v-if="registration.committee.candidacy.jurisdiction">
            {{ registration.committee.candidacy.jurisdiction | titleCase }}
          </div>
          <div v-if="registration.committee.candidacy.office">
            {{ registration.committee.candidacy.office | titleCase }}
          </div>
          <div v-if="registration.committee.candidacy.position">Position
            {{ registration.committee.candidacy.position }}
          </div>
          <div v-if="registration.committee.candidacy.party"><span
              v-if="registration.committee.candidacy.party === 'NONE' || registration.committee.candidacy.party === 'OTHER' ">Party </span>{{ registration.committee.candidacy.party | titleCase }}
          </div>
          <div v-if="registration.committee.candidacy.email">
            {{ registration.committee.candidacy.email.toLowerCase() }}
          </div>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title><h3>Bank Information</h3></v-card-title>
        <v-card-text>
          <div v-if="registration.committee.bank.name">{{ registration.committee.bank.name | titleCase }}</div>
          <div v-if="registration.committee.bank.branch">{{ registration.committee.bank.branch | titleCase }}</div>
          <div v-if="registration.committee.bank.address">{{ registration.committee.bank.address | titleCase }}</div>
          <div>
            <span v-if="registration.committee.bank.city">{{ registration.committee.bank.city | titleCase }}<span
                v-if="registration.committee.bank.state">,</span></span>
            <span v-if="registration.committee.bank.state"> {{ registration.committee.bank.state }}</span>
            <span v-if="registration.committee.bank.postcode"> {{ registration.committee.bank.postcode }}</span>
          </div>
          <div v-if="registration.committee.books_contact && registration.committee.books_contact.email">To schedule
            books review contact {{ registration.committee.books_contact.email.toLowerCase() }}
          </div>
          <div
              v-if="registration.local_filing && registration.local_filing.seec && registration.local_filing.seec.books_available">
            Books will also be available for inspection for one week preceding the election between
            {{ registration.local_filing.seec.books_available }}
          </div>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title><h3>Officers</h3></v-card-title>
        <v-card-text >
          <div v-if="registration.committee.officers.length">
            <v-card class="officer" v-for="(officer, index) in registration.committee.officers" :key="index">
              <v-card-title><h4>{{ officer.name | titleCase }}</h4></v-card-title>
              <v-card-text>
                <div v-if="officer.title && !(officer.title.toLowerCase() === 'treasurer' && officer.treasurer)">
                  {{ officer.title | titleCase }}
                </div>
                <div v-if="officer.treasurer"><span v-if="officer.ministerial">Ministerial </span>Treasurer</div>
                <div v-if="officer.address">{{ officer.address | titleCase }}</div>
                <div>
                  <span v-if="officer.city">{{ officer.city | titleCase }}<span v-if="officer.state">,</span></span>
                  <span v-if="officer.state"> {{ officer.state }}</span>
                  <span v-if="officer.postcode"> {{ officer.postcode }}</span>
                </div>
                <div v-if="officer.email">{{ officer.email.toLowerCase() }}</div>
                <div v-if="officer.phone">{{ officer.phone }}</div>
                </v-card-text>
            </v-card>
          </div>
          <p v-if="registration.committee.candidacy && registration.committee.candidacy.treasurer">
            Candidate is treasurer.
          </p>
        </v-card-text>
      </v-card>

      <v-card v-if="proposals.length>0">
        <v-card-title><h3>Ballot Propositions</h3></v-card-title>
        <v-card-text>
          <v-card class="proposal" v-for="(proposal,index) in proposals" :key="index">
            <v-card-title>
              <div v-if="proposal.proposal_type === 'recall' && proposal.stance === 'for'">
                {{ $t('message.proposal.for_recall_official', {official: proposal.proposal_issue}) }}
              </div>
              <div v-else-if="proposal.proposal_type === 'recall' && proposal.stance === 'against'">
                {{ $t('message.proposal.against_recall_official', {official: proposal.proposal_issue}) }}
              </div>
              <div v-else-if="proposal.stance === 'for'">
                {{ $t('message.proposal.for') }} {{ proposal.ballot_number | prefix('#') }} <span
                  v-if="!proposal.jurisdiction_id">{{ proposal.proposal_issue }}</span>
              </div>
              <div v-else-if="proposal.stance === 'against'">
                {{ $t('message.proposal.against') }} {{ proposal.ballot_number | prefix('#') }} <span
                  v-if="!proposal.jurisdiction_id">{{ proposal.proposal_issue }}</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="proposal.jurisdiction">{{ proposal.jurisdiction | titleCase }}</div>
              <div v-if="proposal.proposal_type">{{ $t('message.proposal.' + proposal.proposal_type.toLowerCase()) }}
              </div>
              <div v-if="proposal.election_code">{{ proposal.election_code }}</div>
              <div v-else>{{ $t('message.proposal.no_election') }}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card v-if="registration.committee.candidates && registration.committee.candidates.length > 0">
        <v-card-title><h3>Candidate Support or Opposition</h3></v-card-title>
        <v-list>
          <v-list-item v-for="(candidate, index) in registration.committee.candidates" :key="index">
            <v-list-item-title v-if="candidate.stance.toLowerCase() === 'for'">{{ $t('message.proposal.for') }} -
              {{ candidate.person }} for {{ candidate.office }}
            </v-list-item-title>
            <v-list-item-title v-else-if="candidate.stance.toLowerCase() === 'against'">
              {{ $t('message.proposal.against') }} - {{ candidate.person }} for {{ candidate.office }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>

      <v-card v-if="registration.committee.affiliations.length">
        <v-card-title><h3>Affiliations</h3></v-card-title>
        <v-card-text>
          <div v-for="affiliation in registration.committee.affiliations" v-bind:key="affiliation.affiliate_id">
            {{ affiliation.affiliate_name | titleCase }}
          </div>
        </v-card-text>
      </v-card>

      <v-card
          v-if="registration.committee.ticket && (registration.committee.ticket.name || registration.committee.ticket.stance)">
        <v-card-title v-if="registration.committee.ticket.stance === 'for'">{{ $t('message.ticket.for') }}
        </v-card-title>
        <v-card-title v-else-if="registration.committee.ticket.stance === 'against'">
          {{ $t('message.ticket.against') }}
        </v-card-title>
        <v-card-text>
          <div v-if="registration.committee.ticket.name">{{ registration.committee.ticket.name | titleCase }}</div>
          <div v-else>No party indicated</div>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title>
          Attachments
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Description
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="attachment in registration.attachments"
                  :key="attachment.alias"
              >
                <td><a :href="attachment.file_service_url">{{ attachment.file_name }}</a></td>
                <td>{{ attachment.description }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

    </v-sheet>
  </div>
</template>

<script>
import {publicApp as app} from '@/main'

export default {
  name: "Registration",
  data() {
    return {
      registration: null,
      dataLoaded: false,
      registration_id: null,
      amendCommittee: false,
      committee_id: null,
      attachmentsLoaded: false
    }
  },
  created() {
    this.registration_id = this.$route.query.registration_id
    app.$container.dataService.getRegistration(this.registration_id, (registration) => {
      this.registration = registration
      this.committee_id = parseInt(this.registration.committee.committee_id);
      this.dataLoaded = true
    })
  },
  computed: {
    proposals() {
      if (this.registration.committee.proposals) {
        return this.registration.committee.proposals;
      }
      return [];
    },
    isCommitteeView() {
      return this.$route.path.includes('committee');
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.attachmentsLoaded = true;
    })
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  margin-top: 2em;
}

.v-card .v-card__title {
  background-color: lightgray;
  color: black;
  font-size: large;
  font-weight: bold;
  padding-top: 2px;
  padding-bottom: 2px;
}

.officer {
  display: inline-block;
  vertical-align: top;
  margin-right: 1.5em;
}

.officer .v-card__title, .proposal .v-card__title, .identification .v-card__title {
  background-color: unset;
}

#flex-flyout {
  display: block !important;
}

.pdc-logo-div {
  margin-left: 20px;
  width: 140px;
}

svg#pdc-logo-source {
  height: 0;
}
</style>
